import { render, staticRenderFns } from "./CreditCardThirdPartyDataCollapse.vue?vue&type=template&id=03520064&scoped=true&"
import script from "./CreditCardThirdPartyDataCollapse.vue?vue&type=script&lang=js&"
export * from "./CreditCardThirdPartyDataCollapse.vue?vue&type=script&lang=js&"
import style0 from "./CreditCardThirdPartyDataCollapse.vue?vue&type=style&index=0&id=03520064&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03520064",
  null
  
)

export default component.exports